import _ from 'lodash';
import { Address } from 'ui-utils';

import { Language } from '@lib/resources/types';
import { savePatientRequestInterceptor } from '@lib/services/patientsService';

import { LumaBotAnswers } from '../interfaces';

export const getLumaBotPatientData = (answers: LumaBotAnswers, language = Language.English) =>
  savePatientRequestInterceptor({
    language,
    firstname: answers['patient.firstName'],
    lastname: answers['patient.lastName'],
    email: answers['patient.email'],
    phone: answers['patient.phone'],
    dateOfBirth: answers['patient.dob'],
    ..._.omit(answers['patient.address'] as Address, ['value']),
    widget: 'lumabot',
  });
